import styled from 'styled-components';
import PpInfoOutlineIcon from '@pperform/pp-icons/PpInfoOutlineIcon';
import { CONTENT_ALIGNMENT } from '@pperform/pp-constants/widgetConfigs';
import PpErrorIcon from '@pperform/pp-icons/PpErrorIcon';
import PpVisibilityOffIcon from '@pperform/pp-icons/PpVisibilityOffIcon';
import { mediaBreakpointUp } from 'styles/grid';
import { ReactSVG } from 'react-svg';

export const Timeline = styled.div`
  padding: 8px 6px;
`;

export const Event = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0px;
  font-size: ${({ theme }) => theme.configs.fonts.fontSize.eventDetails}px;
`;

export const EventSectionName = styled.h3`
  padding: 8px 2px;
  font-weight: 700;
  font-size: 12px;
  line-height: inherit;
  color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
  text-transform: capitalize;
`;

export const EventsContainer = styled.div<{
  hasRounded: boolean;
}>`
  position: relative;
  margin-left: -2px;

  // separation lines, appear left of events

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    ${(props) => props.hasRounded && 'border-radius: 4px;'}
    background-color: #333333;
  }
`;

export const EventName = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-right: 8px;
  ${mediaBreakpointUp.md} {
    width: 60%;
    margin-right: auto;
  }
`;

export const EventNameLabel = styled.span<{
  isHighlighted: boolean;
  isHiddenEvent: boolean;
}>`
  overflow-wrap: anywhere;
  text-align: left;
  font-weight: ${(props) => {
    return props.isHighlighted ? '700' : '400';
  }};
  cursor: ${(props) => (props.onClick ? 'pointer' : 'text')};
  color: ${(props) => {
    const { theme } = props;
    return props.isHiddenEvent
      ? theme.configs.tertiaryBox.secondaryFontColor
      : 'inherit';
  }};
`;

export const AdditionalInfoName = styled.span`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
`;

export const AdditionalInfoValue = styled.span`
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
`;

export const EventDetails = styled.div`
  margin-left: 10px;
  flex: 1;
  order: 1;
  ${mediaBreakpointUp.md} {
    order: 2;
  }
`;

export const EventLocation = styled.div<{ alignment: CONTENT_ALIGNMENT }>`
  color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};

  ${mediaBreakpointUp.md} {
    text-align: right;
    width: 35%;

    ${({ alignment }) =>
      alignment === CONTENT_ALIGNMENT.LEFT
        ? `
          text-align: left;
          width: 100%;
        `
        : `
          text-align: right;
          width: 35%;
        `}
  }
`;

export const EventMain = styled.div<{ alignment: CONTENT_ALIGNMENT }>`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;

  ${mediaBreakpointUp.md} {
    ${({ alignment }) =>
      alignment === CONTENT_ALIGNMENT.LEFT ? 'flex-direction: column;' : ''}
`;

export const EventTime = styled.h4`
  margin-left: 12px !important;
  font-size: inherit;
  font-weight: inherit;
  color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
  order: 2;
  ${mediaBreakpointUp.md} {
    order: 1;
  }
`;

export const TrackingTime = styled.span`
  min-width: 50px;
  display: block;
  text-align: center;
`;

const eventIcon = `
  flex-shrink: 0;
  flex-basis: content;
`;

export const InfoIcon = styled(PpInfoOutlineIcon).attrs((props) => ({
  rawSvg: true,
  ...props,
}))`
  ${eventIcon}
  width: 13px;
  height: 13px;
  margin-left: 3px;
  cursor: pointer;
`;

export const VisibilityIcon = styled(PpVisibilityOffIcon).attrs((props) => ({
  rawSvg: true,
  ...props,
}))`
  ${eventIcon}
  width: 13px;
  height: 13px;
  margin-left: 3px;
  color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
`;

export const IssueIcon = styled(PpErrorIcon).attrs((props) => ({
  rawSvg: true,
  ...props,
}))`
  ${eventIcon}
  width: 13px;
  height: 13px;
  margin-left: 3px;
`;
